import { KeyCodes } from 'office-ui-fabric-react';
import React, { FunctionComponent, useCallback } from 'react';
import styled from 'styled-components';

import { SrOnlyText } from '../SrOnlyText/SrOnlyText';
import { defaultCardStyle } from '../../Styles';
import { IBaseDetailCardProps } from './BaseDetailCard.types';

/**
 * BaseDetailCard renders to a div
 * If it includes a onCardClick prop, the card will have a box shadow on hover, and will execute onCardClick
 * when the card is clicked or space/enter key is pressed.
 */
const UnstyledBaseDetailCard: FunctionComponent<IBaseDetailCardProps> = props => {
  const { children, onCardClick, screenReaderText, ...otherProps } = props;
  const myRef = React.useRef<HTMLDivElement>(null);
  let onCardClickProps = {};

  const onKeyPress = useCallback(
    (ev: React.KeyboardEvent<HTMLElement>) => {
      if (ev.charCode in { [KeyCodes.enter]: 1, [KeyCodes.space]: 1 } && myRef.current && ev.target && myRef.current === ev.target) {
        onCardClick && onCardClick(ev);
        ev.preventDefault();
        ev.stopPropagation();
      }
    },
    [myRef, onCardClick]
  );

  if (onCardClick) {
    onCardClickProps = {
      ref: myRef,
      onKeyPress,
      onClick: onCardClick,
      tabIndex: 0,
    };
  }

  return (
    <div {...onCardClickProps} {...otherProps}>
      {screenReaderText && <SrOnlyText>{screenReaderText}</SrOnlyText>}
      {children}
    </div>
  );
};

export const BaseDetailCard = styled(UnstyledBaseDetailCard)`
  background: rgb(255, 255, 255);
  border-radius: 0px;
  box-shadow: 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13), 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.11);
  ${props => (props.onCardClick ? defaultCardStyle : '')}
`;

export default BaseDetailCard;
